export enum IntentScenario {
  BH_CRISIS = 'BH-CRISIS',
  NON_BH_CRISIS = 'NON-BH-CRISIS',
  BH_NON_CRISIS = 'BH-NON-CRISIS',
  IGNORE = 'IGNORE'
}
